import React from 'react';
import { Modal } from '@/components/Layout';
import { ContentType, GENERATION_OPTIONS } from './types';

import { ContentGenerationOptionCard } from './ContentGenerationOptionCard';

interface ContentGenerationOptionsProps {
  isOpen: boolean;
  onClose: () => void;
  onOptionSelect: (contentType: ContentType) => void;
}

export const ContentGenerationOptions: React.FC<
  ContentGenerationOptionsProps
> = ({ isOpen, onClose, onOptionSelect }) => {
  return (
    <Modal
      headerStyle="bg-[#2A2A2A] !h-[50px]"
      modalStyle="bg-[#2A2A2A] min-w-[24.4375rem] max-w-[700px]"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="grid grid-cols-2 gap-4 mt-8">
        {GENERATION_OPTIONS.map((option) => (
          <ContentGenerationOptionCard
            key={option.contentType}
            icon={option.icon}
            title={option.title}
            description={option.description}
            contentType={option.contentType}
            onClick={onOptionSelect}
          />
        ))}
      </div>
    </Modal>
  );
};
